export default __webpack_public_path__ + "static/media/drag.5f33ee4b.svg";